var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"ecvNavbar__submenu",attrs:{"id":"ecvNavbar__submenu"}},[_c('div',{staticClass:"ecvNavbar__submenu__content d-flex"},_vm._l((_vm.secondaryItems),function(secondaryItem,secondaryIndex){return _c('sub-menu-second',{key:secondaryItem.id,attrs:{"data":secondaryItem,"index":secondaryIndex}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }